import type { Address } from "../types";

export const formatAddress = (address: Address) => {
  return `${address.street} ${address.number}, ${address.zip} ${address.city}`;
};
